import { ArchiveIcon } from "lucide-react";
import { cn } from "~/lib/utils";

export const EmptySpace = ({
  title,
  className,
}: {
  title: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "w-full h-[222px] bg-background flex-col justify-center items-center gap-2.5 inline-flex",
        className
      )}
    >
      <div className="flex-col justify-start items-center gap-6 flex">
        <ArchiveIcon className="w-10 h-10 text-muted-foreground" />
        <div className="self-stretch text-center text-muted-foreground text-base font-normal leading-normal">
          {title}
        </div>
      </div>
    </div>
  );
};
